exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".query-area[data-v-e7cd3070] {\n  margin-bottom: 20px;\n}\n.action-detail[data-v-e7cd3070] {\n  min-width: 100px !important;\n  color: #0077fa !important;\n  cursor: pointer !important;\n  white-space: normal;\n}\n.search-space[data-v-e7cd3070] {\n  width: 140px;\n  margin-right: 15px;\n}\n.label-item[data-v-e7cd3070] {\n  margin: 0 4px;\n  padding: 2px 8px;\n  color: #575757;\n  background-color: #fafafa;\n  border-radius: 12px;\n  white-space: normal;\n}\n[data-v-e7cd3070] .ant-table td {\n  white-space: break-spaces;\n}\n", ""]);

// exports
